<template>
  <v-container fluid id="login" fill-height style="overflow=hidden">
    <v-layout align-center justify-center column fill-height>
      <div class="display-1 mb-2 font-weight-regular" style="color: black">
        <v-layout row wrap>
          <v-flex shrink>
            <img :src="brandConfig.logos.inline" height="38" />
          </v-flex>
        </v-layout>
      </div>
      <div>
        <span class="body-2">{{ $t("pageHeader.backOffice") }}</span>
      </div>
      <router-view class="mt-4" />
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "authentication",
  data() {
    return {
      isStoreSync: false,
    };
  },
  created() {
    this.detectBrand();
  },
  computed: {
    ...mapGetters("brand", ["currentBrand", "brandConfig"]),
  },
  methods: {
    detectBrand() {
      const host = window.location.hostname.toLowerCase();
      // ✅ Adjust domains as needed
      if (host.includes("storesyncpos")) {
        this.isStoreSync = true;
      } else if (host.includes("autorepairdesk")) {
        this.isStoreSync = false;
      } else {
        // fallback to StoreSyncPOS by default
        this.isStoreSync = true;
      }
    },
  },
};
</script>
<style scoped>
#login {
  background-color: #ebedf1;
}
</style>
